import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from '#imports';

export default defineNuxtRouteMiddleware((to) => {
  const nuxtApp = useNuxtApp();
  const auth = nuxtApp.$vuex?.state?.auth;
  const user = auth?.user;

  if (user?.isObserver) {
    return navigateTo({
      name: 'theme-admin-accounts-accountSlug-projectSlug',
      params: {
        theme: to.params.theme,
        accountSlug: to.params.accountSlug,
        projectSlug: to.params.projectSlug,
      },
    });
  }
});
